'use client'

import type { ReturnMethodContent } from 'shipping-and-returns/types/ReturnsInfo.types'
import { cx } from 'utils/cx'

import styles from './SingleReturnInfo.module.scss'
import text from 'fukku/styles/texts.module.scss'

export function SingleReturnInfo({
	className,
	methodInfo,
}: {
	readonly className?: string
	readonly methodInfo: ReturnMethodContent
}) {
	const { title, content } = methodInfo

	return (
		<div
			className={cx(styles.container, className)}
			data-testid='myReturns.returnMethods.singleMethod'
		>
			<div className={`${text.titleM} ${styles.title}`}>{title}</div>
			{content}
		</div>
	)
}
